import React from "react";
import Th from "./Th";
import StatusBadge from "./StatusBadge";
import GroupedTripLink from "./GroupedTripLink";
import { formatDate } from "./helpers";

// `compact` is used when IssuesPanel takes the donut card's slot in the
// PlatformAndVehicleSection — the body gets a fixed max height and scrolls
// internally so the grid row matches the donut card's natural height. The
// column layout mirrors GroupedTripsTable for visual uniformity, swapping
// Duration for Reason (issues carry a reason, not a duration).
const IssuesPanel = ({ issues, compact = false }) => {
  const Wrapper = compact ? "div" : "section";
  return (
    <Wrapper className={compact ? "" : "bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm"}>
      <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 flex justify-between items-center">
        <h3 className="text-[12px] uppercase tracking-widest text-gray-500 font-semibold">
          Issues — Open + Cancelled Early ({issues.length})
        </h3>
      </div>
      {issues.length === 0 ? (
        <div className="p-6 text-sm text-gray-500 italic">
          No issues this week.
        </div>
      ) : (
        <div className={`overflow-x-auto ${compact ? "max-h-[240px] overflow-y-auto" : ""}`}>
          <table className="w-full text-left border-collapse">
            <thead className={`bg-gray-50/50 border-b border-gray-200 ${compact ? "sticky top-0 bg-white z-10" : ""}`}>
              <tr>
                <Th>Date &amp; Time</Th>
                <Th>Grouped Trip ID</Th>
                <Th>Status</Th>
                <Th>Reason</Th>
                <Th align="right">Distance</Th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {issues.map((issue) => (
                <tr key={issue.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-[14px] font-medium">{formatDate(issue.occurred_at)}</td>
                  <td className="px-4 py-3 text-[13px] font-mono">
                    <GroupedTripLink id={issue.id} label={issue.grouped_trip_code} />
                  </td>
                  <td className="px-4 py-3">
                    <StatusBadge status={issue.status} />
                  </td>
                  <td className="px-4 py-3 text-[13px] text-gray-500 italic">
                    {issue.reason || "—"}
                  </td>
                  <td className="px-4 py-3 text-[13px] text-gray-500 text-right">
                    {issue.distance_km?.toFixed(1)} km
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Wrapper>
  );
};

export default IssuesPanel;
